var styleDataHash = "f820c19f";
const injectCss = () => {
  var css = `.MGeay{height:18px;position:relative;width:18px}._7WRhU,.ue7IL{height:100%;position:absolute;top:0;width:100%;fill:none;stroke-linecap:round}[dir=ltr] ._7WRhU,[dir=ltr] .ue7IL{left:0}[dir=rtl] ._7WRhU,[dir=rtl] .ue7IL{right:0}.ue7IL{stroke:currentColor;opacity:.3}[dir=ltr] .ue7IL{animation:_7lNGa 666ms linear infinite}[dir=rtl] .ue7IL{animation:fbJlJ 666ms linear infinite}._7WRhU{stroke:currentColor}[dir=ltr] ._7WRhU{animation:_7lNGa 2s linear infinite}[dir=rtl] ._7WRhU{animation:fbJlJ 2s linear infinite}@keyframes _7lNGa{to{transform:rotate(1turn)}}@keyframes fbJlJ{to{transform:rotate(-1turn)}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var double_loader_default = {
  "wrapper": "MGeay",
  "top": "ue7IL",
  "bottom": "_7WRhU",
  "rotation-ltr": "_7lNGa",
  "rotation-rtl": "fbJlJ"
};
export {
  double_loader_default as default,
  injectCss
};
//# sourceMappingURL=double-loader-scss.js.map
